// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"184":"70067b3d","344":"62dfbc1c","390":"bd897543","600":"39c9beb6","682":"a03c5bd1","799":"721cf826","874":"64331961"}[chunkId] + ".js";
};